@if (enableNewsletterSignUpForm && (isLoggedInUser$ | async) === false) {
  <div
    data-testid="newsletter-sign-up-form"
    class="newsletter-signup-form form-container service-form ms-large-t col-1-12"
  >
    @if (reactiveForm && formStatus !== FormStatus.COMPLETE) {
      <div class="col-1-12 form-container">
        <h2>{{ 'newsletterSignUpForm.title' | finLocalization }}</h2>
        <div class="font-body-1 regular-type font-body-medium">
          {{ 'newsletterSignUpForm.subtitle' | finLocalization }}
        </div>
        @if (reactiveForm && (formStatus === FormStatus.INITIAL || formStatus === FormStatus.INITIALIZING_ERROR)) {
          <div
            class="font-body-1 regular-type pr-xxsmall-t font-body-medium"
            [class.pr-small-b]="
              reactiveForm && (formStatus === FormStatus.INITIAL || formStatus === FormStatus.INITIALIZING_ERROR)
            "
          >
            {{ 'newsletterSignUpForm.mandatoryFields' | finLocalization }}
          </div>

          <form [formGroup]="reactiveForm" (ngSubmit)="onSubmit()" autocomplete="off">
            <div class="flex flex--wrap columns-2">
              <fcom-text-input
                class="flex-1"
                [parentForm]="reactiveForm"
                [translationPrefix]="'newsletterSignUpForm.formDetails.firstName'"
                [controlName]="'firstName'"
                [placeHolder]="'newsletterSignUpForm.formDetails.firstName.placeholder'"
              />

              <fcom-text-input
                class="flex-1"
                [parentForm]="reactiveForm"
                [translationPrefix]="'newsletterSignUpForm.formDetails.lastName'"
                [controlName]="'lastName'"
                [placeHolder]="'newsletterSignUpForm.formDetails.lastName.placeholder'"
              />
            </div>

            <fcom-text-input
              [parentForm]="reactiveForm"
              [translationPrefix]="'newsletterSignUpForm.formDetails.email'"
              [controlName]="'email'"
              [placeHolder]="'newsletterSignUpForm.formDetails.email.placeholder'"
              [inputType]="InputType.EMAIL"
            />

            <div class="flex flex--wrap columns-2">
              <fin-select-input
                class="flex-1"
                [parentForm]="reactiveForm"
                [controlName]="'country'"
                [options]="countries"
                [selectLabelTranslationKey]="'newsletterSignUpForm.formDetails.country.placeholder'"
                [translationPrefix]="'newsletterSignUpForm.formDetails.country'"
                (change)="countryChanged(reactiveForm.get('country').value)"
              />

              @if (languages?.length !== 1) {
                <fin-select-input
                  class="flex-1"
                  [parentForm]="reactiveForm"
                  [controlName]="'language'"
                  [options]="languages"
                  [selectLabelTranslationKey]="'newsletterSignUpForm.formDetails.language.placeholder'"
                  [translationPrefix]="'newsletterSignUpForm.formDetails.language'"
                />
              } @else {
                <div>
                  <div data-testid="newsletter-signup-language" class="ps-xxsmall-b ms-xlarge-b">
                    <span
                      class="font-body-1 regular-type block nordic-blue-400-text text-icon-secondary font-body-medium"
                    >
                      {{ 'newsletterSignUpForm.languageTitle' | finLocalization }}
                    </span>
                    <div class="font-body-1 font-body-medium">{{ languages?.[0]?.name }}</div>
                  </div>
                </div>
              }
            </div>

            <div class="font-body-1 font-body-medium">
              <span class="block ms-xsmall-b">{{
                'newsletterSignUpForm.formDetails.checkAtLeastOne' | finLocalization
              }}</span>
              <fcom-checkbox-input
                class="block ms-small-b"
                [controlName]="'marketingNewsletter'"
                [parentForm]="reactiveForm"
              >
                <span>
                  {{ 'newsletterSignUpForm.formDetails.marketingNewsletter' | finLocalization }}
                </span>
              </fcom-checkbox-input>

              <fcom-checkbox-input [controlName]="'advertising'" [parentForm]="reactiveForm">
                <span>
                  {{ 'newsletterSignUpForm.formDetails.advertising' | finLocalization }}
                </span>
              </fcom-checkbox-input>

              @if (
                reactiveForm.get('marketingNewsletter').touched &&
                !reactiveForm.get('marketingNewsletter').value &&
                reactiveForm.get('advertising').touched &&
                !reactiveForm.get('advertising').value
              ) {
                <div
                  class="error-900-text signal-error-notification-border-icon-text font-body-1 ms-xsmall-t font-body-medium"
                  data-testid="required-error"
                >
                  {{ 'newsletterSignUpForm.formDetails.required' | finLocalization }}
                </div>
              }

              <div
                class="ms-large-y"
                [innerHTML]="'newsletterSignUpForm.formDetails.newsLetterTerms' | finLocalization | finSafe: 'html'"
              ></div>
            </div>

            @if (formStatus === FormStatus.INITIALIZING_ERROR) {
              <fcom-notification [theme]="NotificationTheme.ALERT" class="ms-xlarge-y">
                {{ 'errors.generic.title' | finLocalization }}
              </fcom-notification>
            }

            <div class="flex flex--end ms-small-y">
              <fcom-button
                data-testid="newsletter-signup-submit"
                (clickBtn)="onSubmit()"
                [text]="'newsletterSignUpForm.submit' | finLocalization"
              />
            </div>
          </form>
        }
      </div>

      @if (formStatus === FormStatus.LOADING) {
        <div class="mr-xlarge-y center col-1-12">
          <fcom-loader [loaderType]="LoaderTheme.EMBEDDED" />
        </div>
      }

      @if (errorArticle$ | async; as error) {
        @if (formStatus === FormStatus.ERROR) {
          <div data-testid="newsletter-signup-already-signup" class="col-1-12">
            <h3>{{ error.teaserTitle }}</h3>
            <div class="error" [innerHTML]="error.teaserText | finSafe: 'html'"></div>
          </div>
        }
      }
    } @else {
      <div data-testid="newsletter-sign-up-success" class="col-1-12">
        <div class="df-mobile flex--left-center">
          <fcom-icon
            class="icon-large nordic-blue-900-text text-icon-primary mr-xsmall-b"
            [name]="SvgLibraryIcon.CHECKMARK_OUTLINE"
          />
        </div>
        <h3>{{ 'newsletterSignUpForm.success.title' | finLocalization }}</h3>
        <div class="font-body-1 regular-type font-body-medium">
          {{ 'newsletterSignUpForm.success.subtitle' | finLocalization: { email: reactiveForm.get('email').value } }}
        </div>
      </div>
    }
  </div>
}
